import React from "react";
import {
  actionGetEquipamentos,
  actionGetUnidadeDeMedida,
} from "../../features/equipamentos/slices";
import { actionGetGrupoMonitoramento } from "../../features/grupos-de-monitoramento/slices";
import {
  actionResetModulos,
  actionSelectEntradaModulo,
} from "../../features/modulo/slices";
import { actionGetConfigPtMonAnalogico } from "../../features/monitoramento/analogico/get-monitoramento/slices";
import { actionGetConfigPtMonDigital } from "../../features/monitoramento/digital/get-monitoramento/slices";
import { actionGetConfigPtMonMedidor } from "../../features/monitoramento/medidores/get-monitoramento/slices";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";
import Alert from "../Alert";
import Tag from "../Tag";
import "./_styles.scss";

const Modulos = ({ cb }: any) => {
  const dispatch = useAppDispatch();

  const data = useAppSelector((state) => state.modulosByCentral.data);
  const status = useAppSelector((state) => state.modulosByCentral.status);
  const centraisByLoja = useAppSelector((state) => state.centraisByLoja);

  console.log("data modulos", data);

  console.log("status modulos", status);

  console.log("centraisByLoja modulos", centraisByLoja);

  const selectEntrada = (data: any) => {
    dispatch(actionSelectEntradaModulo(data));
    dispatch(actionGetEquipamentos(data.entrada.tipo));
    dispatch(actionGetUnidadeDeMedida());
    dispatch(actionGetGrupoMonitoramento());
    if (data.entrada.ocupada) {
      if (data.entrada.tipo === "A") {
        dispatch(actionGetConfigPtMonAnalogico());
      } else if (data.entrada.tipo === "D") {
        dispatch(actionGetConfigPtMonDigital());
      } else if (data.entrada.tipo === "R") {
        dispatch(actionGetConfigPtMonMedidor());
      }
    }
    cb();
  };

  React.useEffect(() => {
    if (centraisByLoja.status === "loading") {
      dispatch(actionResetModulos());
    }
  }, [centraisByLoja.status]);

  if (status === "loading")
    return (
      <strong className="paragraph--sm color-primary">
        Carregando modulos...
      </strong>
    );
  if (status === "success" && data.length === 0)
    return (
      <strong className="paragraph--sm color-primary">
        A central selecionada não possui modulos
      </strong>
    );
  if (status === "error") return <Alert type="error">Algo deu errado</Alert>;

  return (
    <div className="wrapper-modulos">
      {data.map((modulo: any) => (
        <div
          className="card-entradas"
          key={`modulo-${modulo.idCentral}-${modulo.adrModulo}`}
        >
          <header>
            <Tag size="sm" tooltip="Endereço: idCentral - endereço modulo">
              Endereço: {modulo.idCentral} - {modulo.adrModulo}
            </Tag>
          </header>

          <section>
            <p>Entradas digitais</p>
            <div className="card-entradas__list">
              {modulo.entradas.digitais.map((entrada: any) => (
                <button
                  key={`digital-${modulo.idCentral}-${modulo.adrModulo}-${entrada.id}`}
                  className={entrada.ocupada ? `busy` : `free`}
                  onClick={() => selectEntrada({ modulo, entrada })}
                >
                  {entrada.id}
                </button>
              ))}
            </div>
          </section>

          <section>
            <p>Entradas analógicas</p>
            <div className="card-entradas__list">
              {modulo.entradas.analogicas.map((entrada: any) => (
                <button
                  key={`analog-${modulo.idCentral}-${modulo.adrModulo}-${entrada.id}`}
                  className={entrada.ocupada ? `busy` : `free`}
                  onClick={() => selectEntrada({ modulo, entrada })}
                >
                  {entrada.id}
                </button>
              ))}
            </div>
          </section>

          <section>
            <p>Medidores</p>
            <div className="card-entradas__list">
              {modulo.entradas.medidores.map((entrada: any) => (
                <button
                  key={`medidor-${modulo.idCentral}-${modulo.adrModulo}-${entrada.id}`}
                  className={entrada.ocupada ? `busy` : `free`}
                  onClick={() => selectEntrada({ modulo, entrada })}
                >
                  {entrada.id}
                </button>
              ))}
            </div>
          </section>
        </div>
      ))}
    </div>
  );
};
export default Modulos;
